import { Tag } from "primereact/tag";
import "./status-tag.scss";
import { useCallback } from "react";

/* eslint-disable-next-line */
export interface StatusTagProps {
  status: string;
}

export function StatusTag({ status }: StatusTagProps) {
  const getSeverity = useCallback(() => {
    switch (status) {
      case "ON-GOING":
        return "info";
      case "COMPLETED":
        return "success";
      case "CANCELLED":
        return "danger";
    }
  }, [status]);

  return (
    <div id="StatusTag" className="status-tag">
      <Tag value={status} severity={getSeverity()}></Tag>
    </div>
  );
}

export default StatusTag;
